import React, { useEffect, useMemo } from "react";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import {
  changeDateRangeFrom,
  changeDateRangeTo,
} from "../../../redux/reducers/dateRange";

const START_YEAR = 2024;

const StyledSelect = styled(Select)`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
  background-color: ${({ theme }) => theme.colors.red};
  border-radius: 14px;
  max-width: 117px;
  height: 36px;

  svg {
    color: white;
  }

  .year-select {
    width: 100px;

    &__control {
      border: none !important;
      box-shadow: none !important;
      background-color: transparent !important;

      &:hover {
        border: none;
      }
    }

    &__value-container {
      justify-content: center;
    }

    &__single-value {
      text-align: center;
      color: white !important;
    }

    &__menu {
      background-color: #f8f9fa;
    }

    &__separator {
      display: none;
    }

    &__indicator-separator {
      display: none;
    }
  }
`;

const SelectWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const YearPicker = () => {
  const dispatch = useDispatch();
  const selectedYear = useSelector((state) => state.dateRange.dateFrom);

  const currentYear = new Date().getFullYear();

  const yearOptions = useMemo(() => {
    const options = [];

    // eslint-disable-next-line no-plusplus
    for (let year = START_YEAR; year <= currentYear; year++) {
      options.push({
        value: year.toString(),
        label: year.toString(),
      });
    }

    return options;
  }, [currentYear]);

  useEffect(() => {
    if (!selectedYear) {
      const year = currentYear.toString();
      dispatch(changeDateRangeFrom(`${year}-01-01`));
      dispatch(changeDateRangeTo(`${year}-12-31`));
    }
  }, [currentYear, selectedYear, dispatch]);

  const handleYearChange = (option) => {
    const year = option.value;
    dispatch(changeDateRangeFrom(`${year}-01-01`));
    dispatch(changeDateRangeTo(`${year}-12-31`));
  };

  return (
    <SelectWrapper>
      <StyledSelect
        value={yearOptions.find(
          (option) => option.value === selectedYear?.split("-")[0]
        )}
        onChange={handleYearChange}
        options={yearOptions}
        className="year-select"
        classNamePrefix="year-select"
        placeholder="Select year"
        isSearchable={false}
      />
    </SelectWrapper>
  );
};

export default YearPicker;
